import { render, staticRenderFns } from "./Profesionales.vue?vue&type=template&id=1f1f7525&scoped=true&"
import script from "./Profesionales.vue?vue&type=script&lang=js&"
export * from "./Profesionales.vue?vue&type=script&lang=js&"
import style0 from "./Profesionales.vue?vue&type=style&index=0&id=1f1f7525&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1f7525",
  null
  
)

export default component.exports